`<template>
  <div>
    <Breadcrumb :headers="headers"></Breadcrumb>
    <div  style='margin:200px  300px;'>
       <p  class='legal'>The information is provided by AKUVOX (XIAMEN) NETWORKS CO., LTD. and while we endeavour to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, 
        or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk. </p>
        <br>
        <p  class='legal'>AKUVOX hereby authorizes and requires Distributor/Partner's use of AKUVOX's insignia or lettering which will be on the marketing & product materials available on Akuvox Certified Partner (CAP) program portal. </p>
        <br>
        <p  class='legal'>Partners should maintain the accuracy of information in the use of these materials. After discussion in advance and authorization from Akuvox, the information can be modified due to actual usage. Akuvox does not authorize any certified partner/distributor to delete or modify AK trademarks and logos in all materials. </p>
    </div>
  </div>
    
</template>

<script>

import Breadcrumb from "../components/common/Breadcrumb.vue";

export default {
    components: {
        Breadcrumb
    },
    data() {
        return {
            headers:[{label:"Home",path:"/dashboard"},{label:"Legal",path:"/legal"}] 
        };
    },
    methods: {
        
    }
};
</script>
<style scoped>
    .legal{
        text-indent:2em;  /*首行缩进 */
        font-size:16px;
        line-height: 30px;  /*行高 行距*/
        text-align:justify;  /*每行等宽  自动调整间距 美化 */
    }
</style>
